import { Selector } from 'react-redux';
import { StaticPageSimple } from '../../services/staticPages/staticPages';
import type { RootState } from '../index';

export const getIsHeaderVisible: Selector<RootState, boolean> = (state) => state.layout.isHeaderVisible;

export const getIsCookieVisible: Selector<RootState, boolean> = (state) => state.layout.isCookieVisible;

export const getStaticPages: Selector<RootState, StaticPageSimple[]> = (state) => state.layout.staticPages;
